module.exports = __webpack_public_path__ + "img/aging_test.785a310e.jpg";